import { HECTARE, TREE } from 'services/perUnitTypes/types';

const options: Record<string, any>[] = [
    {
        key: HECTARE,
        text: HECTARE,
        value: HECTARE
    },
    {
        key: TREE,
        text: TREE,
        value: TREE
    }
];

export { options };
